const COMPANY_ID = 'RxXVzG';
const LIST_ID = 'WgvxMs';

const selectors = {
  form: 'form',
  input: 'input',
  variantInput: 'product-form [data-variant-id]',
  button: '[data-bis-button]'
}

class ComponentBackInStockForm extends HTMLElement {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
    this.setupEventListeners = this.setupEventListeners.bind(this);
    this.removeEventListeners = this.removeEventListeners.bind(this);
  }

  async onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.button?.setAttribute('aria-busy', true);

    const formData = new FormData(this.form);
    const email = formData.get('email');

    const variantInput = document.querySelector(selectors.variantInput);
    const variantId = variantInput.value;

    if (!email || !variantId) {
      console.error('Email and variant ID are required');
      this.button?.removeAttribute('aria-busy');
      return;
    }

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": `${email}`,
              }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        revision: "2023-12-15"
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`, requestOptions)

    if (!response.ok) {
      console.error('Failed to subscribe to back in stock list');
      this.button?.removeAttribute('aria-busy');
      return;
    }

    this.button?.removeAttribute('aria-busy');
    this.button?.setAttribute('data-state', 'success');
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onSubmit);
  }

  removeEventListeners() {
    this.form.removeEventListener('submit', this.onSubmit);
  }

  connectedCallback() {
    this.form = this.querySelector(selectors.form);
    this.input = this.querySelector(selectors.input);
    this.button = this.querySelector(selectors.button);

    if (!this.form || !this.input) return;

    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', ComponentBackInStockForm);
}